var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MixedKeyboard',{attrs:{"callbacks":_vm.callbacks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }